import { appointmentConst } from '../../../../../../constants';
import { ModalView } from '../../../../../uiComponents';
import { CustomerForm } from '../../../../Customer/CustomerForm';
import { NoteHistoryBody } from '../../../../Note/NoteHistoryBody';

export const AppointmentModals = ({
  isNotesModalOpen,
  setIsNotesModalOpen,
  customerId,
}) => {
  return (
    <>
      <ModalView title={appointmentConst.ADD_PATIENT} width={900}>
        <CustomerForm onModal />
      </ModalView>

      <ModalView
        title={appointmentConst.NOTES}
        open={isNotesModalOpen}
        onCancel={() => setIsNotesModalOpen(false)}
        width="100%"
      >
        <NoteHistoryBody customerId={customerId} hideDeleteButton />
      </ModalView>
    </>
  );
};
